import { render } from "./MessagesIcon.vue?vue&type=template&id=208f86e0"
const script = {}
script.render = render

export default script